export enum WebsiteEnquiryStatus {
  New = "new",
  Archived = "archived"
}

export interface WebsiteEnquiry {
  id: number;
  status: WebsiteEnquiryStatus;
  dateCreated: Date;
  dateUpdated?: Date;
  dateArchived?: Date;
  name?: string;
  email?: string;
  phone?: string;
  postcode?: string;
  message?: string;
  service?: string;
  rawSubmittedData?: any;
}
